import React, { useState, useEffect } from 'react';
import DashboardOverview from './DashboardOverview';
import MenuManagement from './menu-management/MenuManagement';
import Orders from './Orders';

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('menu');
  const [menuSections, setMenuSections] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Close sidebar when clicking outside on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      const sidebar = document.getElementById('sidebar');
      const toggleButton = document.getElementById('sidebar-toggle');
      
      if (isSidebarOpen && 
          sidebar && 
          !sidebar.contains(event.target) && 
          toggleButton && 
          !toggleButton.contains(event.target)) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSidebarOpen]);

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Mobile Header */}
      <div className="md:hidden bg-gold-dark text-white p-4 flex justify-between items-center">
        <h2 className="text-xl font-bold text-white">Restaurant Manager</h2>
        <button 
          id="sidebar-toggle"
          className="text-white focus:outline-none"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>
      </div>

      <div className="flex flex-col md:flex-row">
        {/* Sidebar - Hidden on mobile unless toggled */}
        <div 
          id="sidebar"
          className={`
            bg-gold-dark text-white 
            md:w-fit md:flex md:flex-col md:h-screen md:fixed 
            transform transition-transform duration-300 ease-in-out
            ${isSidebarOpen ? 'fixed inset-y-0 left-0 w-64 z-20' : 'fixed -left-64 md:left-0 w-64 z-20'}
          `}
        >
          {/* Close button for mobile */}
          <div className="md:hidden p-4 flex justify-between items-center">
            <h2 className="text-xl font-bold text-white">Restaurant Manager</h2>
            <button 
              className="text-white focus:outline-none"
              onClick={() => setIsSidebarOpen(false)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>

          {/* Desktop header */}
          <div className="hidden md:block p-4">
            <h2 className="text-2xl font-bold text-white">Restaurant Manager</h2>
          </div>

          <nav className="mt-6 flex-grow">
            <button 
              className={`flex items-center px-6 py-3 w-full text-left ${activeTab === 'dashboard' ? 'bg-amber-50/30 border-l-4 border-amber-300' : ''}`}
              onClick={() => {
                setActiveTab('dashboard');
                setIsSidebarOpen(false);
              }}
            >
              <span className="mx-2">Dashboard</span>
            </button>
            <button 
              className={`flex items-center px-6 py-3 w-full text-left ${activeTab === 'menu' ? 'bg-amber-50/30 border-l-4 border-amber-300' : ''}`}
              onClick={() => {
                setActiveTab('menu');
                setIsSidebarOpen(false);
              }}
            >
              <span className="mx-2">Menu Management</span>
            </button>
            <button 
              className={`flex items-center px-6 py-3 w-full text-left ${activeTab === 'orders' ? 'bg-amber-50/30 border-l-4 border-amber-300' : ''}`}
              onClick={() => {
                setActiveTab('orders');
                setIsSidebarOpen(false);
              }}
            >
              <span className="mx-2">Orders</span>
            </button>
          </nav>
        </div>

        {/* Overlay when sidebar is open on mobile */}
        {isSidebarOpen && (
          <div 
            className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-10"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}

        {/* Main Content */}
        <div className="md:ml-64 flex-1 p-4 md:p-8 w-full">
          {activeTab === 'dashboard' && <DashboardOverview />}

          {activeTab === 'menu' &&
              <MenuManagement 
                menuSections={menuSections} 
                setMenuSections={setMenuSections}
              />
          }

          {activeTab === 'orders' && (
            <Orders menuSections={menuSections} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;